import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconCalendarToday.tsx
const OutlinedFilledCalendarToday = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z" })
});
const OutlinedCalendarToday = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z" })
});
const RoundedFilledCalendarToday = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z" })
});
const RoundedCalendarToday = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z" })
});
const SharpFilledCalendarToday = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Z" })
});
const SharpCalendarToday = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z" })
});
const componentMap = {
	outlined: OutlinedCalendarToday,
	"outlined-fill": OutlinedFilledCalendarToday,
	rounded: RoundedCalendarToday,
	"rounded-fill": RoundedFilledCalendarToday,
	sharp: SharpCalendarToday,
	"sharp-fill": SharpFilledCalendarToday
};
const IconCalendarToday = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconCalendarToday };